import { render, staticRenderFns } from "./FormCompanyAdmin.vue?vue&type=template&id=aa2e6eb4"
import script from "./FormCompanyAdmin.vue?vue&type=script&lang=js"
export * from "./FormCompanyAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports